import { AgendaSlotType } from '@omecare/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import http from '@/utils/http.service';

export const useUpdateAgendaSlotAssistantModeMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({
      agendaSlotId,
      forceWithoutAssistant,
      type,
    }: {
      agendaSlotId: string;
      forceWithoutAssistant?: boolean;
      type?: AgendaSlotType;
    }) => {
      // `withAssistant` is deliberately not sent: the UI never pins AA/SA, it
      // only toggles the SA override / consultation mode, and the server then
      // re-infers the mode from the assistant planning.
      return http.agendaSlots
        .updateAssistantMode(agendaSlotId, {
          forceWithoutAssistant,
          type,
        })
        .then((response) => response);
    },
    onSuccess: () => {
      // Invalidate office agenda slots query
      queryClient.invalidateQueries({
        queryKey: ['office-agenda-slots'],
      });
      toast.success(t('http.update-agenda-slot-assistant-mode.success'));
    },
  });
};
